// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2M8sj","colBig":"styles_colBig__3CYpE","colSmall":"styles_colSmall__2YsWi"};